import {
  eventTirggerLabels,
  caseTiggerLabels,
  leadTiggerLabels,
  fileTiggerLabels,
  contactTiggerLabels,
  billingTiggerLabels,
  taskTiggerLabels,
  CREATE_TASK,
  CREATE_EVENT,
  SEND_SECURE_MESSAGE,
  SEND_TEXT_MESSAGE,
  CREATE_FOLDER_STURCTURE,
  BY_PRACTICE_AREA,
  automationModules,
  CREATE_CASE_FILE,
  SEND_SECURE_MESSAGE_REMINDER,
  SEND_TEXT_MESSAGE_REMINDER,
  SHARE_FORM,
} from 'constants/automationConstants';
import { toastConstant } from 'constants/toastmessage';
import { validateAutomationRule } from 'services/settings/workflowAutomation/workflowAutomationServices';
import { ruleValidationTriggers } from 'modules/settings/workflow_automation/configs/ruleValidationTriggers';

const { EVENT_CREATED, EVENT_CANCELLED, EVENT_DATETIME_CHANGED } = eventTirggerLabels || {};

const { CASE_CREATED, CASE_STATUS_CHANGED, CASE_STAGE_CHANGED, CASE_CLOSED } = caseTiggerLabels || {};

const { LEAD_CREATED, LEAD_STATUS_CHANGED, LEAD_CONVERTED_TO_CASE } = leadTiggerLabels || {};

const { NEW_FILE_CREATED, NEW_TEMPLATE_CREATED, ESIGANATURE_STATUS_CHANGED, NEW_FILE_UPLOADED } = fileTiggerLabels || {};
const { NEW_TASK_CREATED, TASK_STATUS_CHANGED } = taskTiggerLabels || {};

const { NEW_PAYMENT_RECEIVED, PAYMENT_REFUNDED, INVOICE_PAST_DUE, PAYMENT_PAST_DUE } = billingTiggerLabels || {};
const { NEW_CONTACT_CREATED } = contactTiggerLabels || {};

const { EVENTS, TASKS, BILLING, CASES, FILES, CONTACTS, LEADS } = automationModules || {};

export const getModuleName = (triggerLabel) => {
  let moduleName = '';

  if ([EVENT_CREATED, EVENT_CANCELLED, EVENT_DATETIME_CHANGED]?.includes(triggerLabel)) {
    moduleName = EVENTS;
  } else if ([NEW_TASK_CREATED, TASK_STATUS_CHANGED]?.includes(triggerLabel)) {
    moduleName = TASKS;
  } else if ([LEAD_CREATED, LEAD_STATUS_CHANGED, LEAD_CONVERTED_TO_CASE]?.includes(triggerLabel)) {
    moduleName = LEADS;
  } else if ([CASE_CREATED, CASE_STATUS_CHANGED, CASE_STAGE_CHANGED, CASE_CLOSED]?.includes(triggerLabel)) {
    moduleName = CASES;
  } else if ([NEW_FILE_CREATED, NEW_TEMPLATE_CREATED, ESIGANATURE_STATUS_CHANGED, NEW_FILE_UPLOADED]?.includes(triggerLabel)) {
    moduleName = FILES;
  } else if (triggerLabel === NEW_CONTACT_CREATED) {
    moduleName = CONTACTS;
  } else if ([NEW_PAYMENT_RECEIVED, PAYMENT_REFUNDED, INVOICE_PAST_DUE, PAYMENT_PAST_DUE]?.includes(triggerLabel)) {
    moduleName = BILLING;
  }

  return moduleName;
};

export const generateCardsMenuLabel = (label = '') => {
  return (
    <div className="d-flex align-items-center justify-content-between pointer">
      <div className="text-bold">{label}</div>
      <div className="addfield">
        <i className="icon-add"></i>
        <label className="pointer">Add</label>
      </div>
    </div>
  );
};

export const generateCardsMenuCondition = (params) => {
  const { globalAutomationData, cardType = '', filterDropdownOptions } = params || {};
  let condition = '';

  if (cardType === 'delay') {
    let otherCardTypes = ['filter', 'action'];

    condition =
      globalAutomationData?.length === 0 || otherCardTypes?.includes(globalAutomationData[globalAutomationData?.length - 1]?.card_type);
  } else if (cardType === 'filter') {
    let otherCardTypes = ['delay', 'action'];

    condition =
      otherCardTypes?.includes(globalAutomationData[globalAutomationData?.length - 1]?.card_type) ||
      (filterDropdownOptions?.length > 0 && filterDropdownOptions?.every((item) => item?.disabled));
  }

  return condition;
};

export const generatePracticeAreaSkToBeSent = (params) => {
  const { practiceAreaOptions = [], filterArr = [] } = params || {};
  let practiceAreaSkList = [];

  if (practiceAreaOptions?.length > 0 && filterArr?.length > 0) {
    let selectedPracticeAreaFilters = [];
    filterArr?.forEach((item, idx) => {
      if (item?.label === BY_PRACTICE_AREA && item?.contains['case_description.case_practice_area']?.length > 0) {
        selectedPracticeAreaFilters = [...selectedPracticeAreaFilters, ...item?.contains['case_description.case_practice_area']];
      }
    });

    selectedPracticeAreaFilters?.forEach((selectedPa) => {
      practiceAreaOptions?.forEach((pa) => {
        if (selectedPa === pa?.value) practiceAreaSkList?.push(pa?.sk);
      });
    });
  }

  return practiceAreaSkList;
};

export const generateAutomationRuleValidationActionCodesList = (globalAutomationData = []) => {
  let ruleValidationActionCodesList = [];

  if (globalAutomationData?.length > 0) {
    globalAutomationData?.forEach((item, idx) => {
      const { card_type, actionType } = item || {};
      if (card_type === 'action') {
        ruleValidationActionCodesList?.push(actionType?.ruleValidationCode);
      }
    });
  }

  return [...ruleValidationActionCodesList];
};

/** ---
 * generateOrderedExecutionDataToBeSent function is used to generate all workflow automation-cards data in payload compatible format
 * This is called in "submitAutomationRule" function
 * --- **/
export const generateOrderedExecutionDataToBeSent = (params) => {
  const { globalAutomationData = [], tenantId = '', tenantSk = '' } = params || {};

  let orderedExecutionDataToBeSent = [];

  try {
    if (globalAutomationData?.length > 0) {
      globalAutomationData?.forEach((item, index) => {
        let tempObject = {};
        if (item?.card_type === 'action' && item?.actionBody) {
          //Adding common values to tempObject. This will be restructured in in each "if-else" conditon
          let { qs_params: qsParams } = item?.actionParams || {};

          tempObject = {
            type: 'action',
            action_code: item?.actionType?.code || '',
            action_label: item?.actionType?.label || '',
            action_unique_identifier: item?.actionBody?.action_unique_identifier || '',

            action_description: {
              params: {
                qs_params: {
                  ...qsParams,
                  ...item?.actionParameters,
                  tenant_id: tenantId,
                  tenant_sk: tenantSk,
                },
                path_params: {},
              },
              body: { ...item?.actionBody },
            },
          };

          if (item?.actionType?.label === CREATE_TASK) {
            tempObject = {
              ...tempObject,
              module: 'TASK',
            };
          } else if (item?.actionType?.label === CREATE_EVENT) {
            tempObject = {
              ...tempObject,
              module: 'EVENT',
            };
          } else if (item?.actionType?.label === SEND_SECURE_MESSAGE || item?.actionType?.label === SEND_SECURE_MESSAGE_REMINDER) {
            tempObject = {
              ...tempObject,
              module: 'MESSAGING',
            };
          } else if (item?.actionType?.label === SEND_TEXT_MESSAGE || item?.actionType?.label === SEND_TEXT_MESSAGE_REMINDER) {
            // let { qs_params: qsParams } = item?.actionParams || {};
            tempObject = {
              ...tempObject,
              module: 'MESSAGING',

              //TODO:Remove after testing
              // action_description: {
              //   params: {
              //     qs_params: {
              //       ...qsParams,
              //       ...item?.actionParameters,

              //       tenant_id: tenantId,
              //       tenant_sk: tenantSk,
              //     },
              //     path_params: {},
              //   },
              //   body: { ...item?.actionBody },
              // },
            };
          } else if (item?.actionType?.label === CREATE_FOLDER_STURCTURE) {
            tempObject = {
              ...tempObject,
              module: 'FILE',
            };
          } else if (item?.actionType?.label === CREATE_CASE_FILE) {
            tempObject = {
              ...tempObject,
              module: 'FILE',
            };
          } else if (item?.actionType?.label === SHARE_FORM) {
            tempObject = {
              ...tempObject,
              module: 'FORMS',
            };
          }

          orderedExecutionDataToBeSent.push(tempObject);
        } else if (item?.card_type === 'delay' && item?.delayExpression && index !== globalAutomationData.length - 1) {
          orderedExecutionDataToBeSent.push({
            type: 'delay',
            delay_expression: item?.delayExpression,
          });
        }
      });
    }
    return orderedExecutionDataToBeSent;
  } catch (error) {
    console.log('Error:In automation - While generating ordered-execution-data', error);
  }
};

export const showToastSuccessMessage = (params) => {
  const { message, addToast } = params || {};

  addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, message);
};

export const showToastErrorMessage = (params) => {
  const { message, addToast } = params || {};

  addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, message);
};

export const getAutomationRuleValidationTriggerName = (ruleTriggersArr = []) => {
  if (ruleValidationTriggers?.length && ruleTriggersArr?.length) {
    let triggerNamesArr = [];

    ruleValidationTriggers?.forEach((trigObj, idx) => {
      ruleTriggersArr?.forEach((item, key) => {
        if (trigObj?.ruleValidationCode === item) {
          triggerNamesArr?.push(trigObj?.label);
        }
      });
    });

    return triggerNamesArr;
  }
};

// Checking if an automation rule is valid or not
export const handleCheckIsValidAutomationRule = async (params = {}) => {
  // status:200 for valid rule
  // status:400 for invalid rule
  let isValidAutomationRule = false;

  const { ruleValidationCheckPayload, setAutomationRuleValidationErrorOptions } = params || {};

  try {
    let validatedAutomationRuleResponse = await validateAutomationRule({ data: ruleValidationCheckPayload });
    const { data, status } = validatedAutomationRuleResponse || {};

    if (data && status === 200) {
      isValidAutomationRule = true;
    }
  } catch (error) {
    console.log('error', error?.response);
    const { status, data } = error?.response || {};

    if (status === 400 && data) {
      setAutomationRuleValidationErrorOptions({
        showRuleValidationErrorDialog: true,
        // ruleValidationErrorData: [...data?.conflicting_rule_triggers],
        ruleValidationErrorData: getAutomationRuleValidationTriggerName([...data?.conflicting_rule_triggers]),
      });
      isValidAutomationRule = false;
    }
  }

  return isValidAutomationRule;
};

export const customHeaderTemplate = (data) => {
  return (
    <div>
      <div className="d-flex">
        <div>
          <i className="icon-window-filled pointer F-size14" onClick={data?.onHide}></i>
          {/* <i className="icon-window-filled pointer F-size14 icon-minimize"></i> */}
        </div>
      </div>
    </div>
  );
};

export const customFooterTemplate = () => {
  return <div></div>;
};

export const generateUniqueIdentifier = (item, index) => {
  const itemString = JSON.stringify(item, (key, value) => {
    if (value === undefined || value === null) {
      return '';
    }
    return value;
  });
  return `unique_${index}_${generateStableHash(itemString)}`;
};

export const generateStableHash = (str) => {
  let hash = 5381;
  for (let i = 0; i < str?.length; i++) {
    hash = (hash * 33) ^ str?.charCodeAt(i);
  }
  return hash >>> 0;
};
